import { HeaderFooterLayout } from '../../app';
import { Button } from '@platform/components';
import ArticlesGrid from './ArticlesGrid';
import PublicationDateString, { PublishDateOrCreatedAt } from './PublicationDateString';
import { BlogArticleSummary } from '../util/types';
import DirectoryContainer from './DirectoryContainer';
import MetaTags from '../../util/MetaTags';
import { getBlogUrl } from './util';

const BlogHomePage = ({ blogArticleSummaries }: { blogArticleSummaries: BlogArticleSummary[] }) => {
  const mostRecentArticle = blogArticleSummaries[0];
  // We only show a subset of articles on this page (30 total as of Dec 2025).
  // The rest are viewable via a 'View All Posts' CTA. Limiting to 30 and sorting by publication date occurs
  // via uses of utils from apps/web/src/app/contentful/blog/util.ts
  const otherArticles = blogArticleSummaries.slice(1);

  return (
    <HeaderFooterLayout>
      <MetaTags
        title='MovingWorlds Blog - Stories, articles, and research to help build leaders that are working to make the world better.'
        description="Inspiring stories and best practices about international volunteering - and how it's solving the talent gap."
        imageUrl='https://images.ctfassets.net/e6h4r2c2hknq/6DfpeDtNazPAYNfBc0v1jt/96bdd92367c4379ad66428f5cf4babfc/problem-solving-collaboratively-ux-indonesia-qC2n6RQU4Vw-unsplash-min.jpg'
      />
      <DirectoryContainer color='white' negativeTopMargin>
        <div className='grid grid-cols-[4fr_2fr] gap-8'>
          <div className='flex flex-col gap-4 mb-8 w-full'>
            <h1 className='text-4xl leading-11 font-bold text-gray-500'>
              {mostRecentArticle.fields.title}
            </h1>
            <span className='text-gray-400'>
              on{' '}
              <PublicationDateString articleEntry={mostRecentArticle as PublishDateOrCreatedAt} /> /{' '}
              {mostRecentArticle.fields.author}
            </span>
            <p
              dangerouslySetInnerHTML={{
                __html: mostRecentArticle.fields.metaDescription,
              }}
            />
            <a className='blue-link' href={getBlogUrl(mostRecentArticle.fields.slug)}>
              Continue reading &gt;
            </a>
          </div>
          <div>
            <img
              style={{
                aspectRatio: 'auto 2560 / 1400',
              }}
              src={mostRecentArticle.fields.bannerImage?.fields.file?.url ?? ''}
              alt='Featured'
            />
          </div>
        </div>
      </DirectoryContainer>
      <DirectoryContainer color='gray'>
        <div className='py-8 flex flex-col gap-8'>
          <h2 className='text-2xl text-gray-700'>Recent Posts</h2>
          <ArticlesGrid articles={otherArticles} />
          <div className='mx-auto'>
            <Button variant='primary' size='xl' href={getBlogUrl('category/all')}>
              View All Posts
            </Button>
          </div>
        </div>
      </DirectoryContainer>
    </HeaderFooterLayout>
  );
};

export default BlogHomePage;
